var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M9.5625 4.5C9.5625 4.18934 9.31066 3.9375 9 3.9375C8.68934 3.9375 8.4375 4.18934 8.4375 4.5V8.4375H4.5C4.18934 8.4375 3.9375 8.68934 3.9375 9C3.9375 9.31066 4.18934 9.5625 4.5 9.5625H8.4375V13.5C8.4375 13.8107 8.68934 14.0625 9 14.0625C9.31066 14.0625 9.5625 13.8107 9.5625 13.5V9.5625H13.5C13.8107 9.5625 14.0625 9.31066 14.0625 9C14.0625 8.68934 13.8107 8.4375 13.5 8.4375H9.5625V4.5Z",
    fill: "#4F16C2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlus);
export default __webpack_public_path__ + "static/media/add-plus.36dc7fb63a1e7778c37436281943ec57.svg";
export { ForwardRef as ReactComponent };